export default {
      id: "map-usage",
      viewBox: "0 0 657 302",
      url: "../dist/images/" + "sprite.svg#map-usage",
      toString: function () {
        return this.url;
      }
    }